module.exports = __webpack_public_path__ + "img/robotIcon-swiper-img1.93a85797.png";